import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import { Platform, View } from 'react-native';
import ConfirmModal from '@/components/SharedComponents/ConfirmModal/ConfirmModal';
import { navigate } from '../../navigations/RootNavigation';
import { isPatientApp } from '@/config/constants';
import { Modal } from '@/components/ui/therapist/Modal';
import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';

export default function SignUpMessages({
  isModalVisible,
  setModalVisible,
  isModalErrorVisible,
  setModalErrorVisible,
  email,
}) {
  const text =
    'Ihre E-Mail-Adresse muss verifiziert werden, bevor Sie neolexon verwenden können. ' +
    'Wir haben Ihnen eine E-Mail an ' +
    JSON.stringify(email) +
    ' zur Verifizierung gesendet. ' +
    'Bitte überprüfen Sie Ihr E-Mail-Postfach.';

  const errorText =
    'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.';
  const responsiveHeight = useResponsiveHeight(100);
  const isFullscreen = Platform.OS !== 'web' && responsiveHeight < 500;

  const handleSuccessSignUp = () => {
    navigate('Login', { email: email });
    setModalVisible(false);
  };

  return isPatientApp ? (
    <View>
      <ConfirmModal
        isVisible={isModalVisible}
        isFullscreen={isFullscreen}
        headerText={'Vielen Dank für Ihre Registrierung!'}
        contentText={text}
        confirmText={'weiter'}
        confirmAction={handleSuccessSignUp}
      />
      <ConfirmModal
        isVisible={isModalErrorVisible}
        isFullscreen={isFullscreen}
        headerText={'Fehler bei der Registrierung'}
        customHeight={30}
        contentText={errorText}
        confirmText={'weiter'}
        confirmAction={() => {
          setModalErrorVisible(false);
        }}
      />
    </View>
  ) : (
    <View>
      <Modal
        onClose={handleSuccessSignUp}
        isVisible={isModalVisible}
        title="Vielen Dank für Ihre Registrierung!"
        confirmActionButton={
          <Button label="Weiter" onPress={handleSuccessSignUp} />
        }
      >
        <Text style={{ fontSize: 18 }}>{text}</Text>
      </Modal>
      <Modal
        isVisible={isModalErrorVisible}
        title="Fehler bei der Registrierung"
        onClose={() => {
          navigate('Login', { email: email });
          setModalErrorVisible(false);
        }}
        confirmActionButton={
          <Button
            label="Weiter"
            onPress={() => {
              setModalErrorVisible(false);
            }}
          />
        }
      >
        <Text style={{ fontSize: 18 }}>{errorText}</Text>
      </Modal>
    </View>
  );
}
